import { useMemo, useState } from "react";
import { Search } from "lucide-react";

// Long lists (contacts, calls, companies) show a few rows; the rest wait behind a search box or "Show all".
// A search shows every match, however many rows are hidden otherwise. Every word typed must match.
export function useListView(items, text, limit = 8) {
  const [query, setQuery] = useState("");
  const [expanded, setExpanded] = useState(false);
  const matched = useMemo(() => {
    const terms = query.toLowerCase().split(/[\s,]+/).filter(Boolean);
    return terms.length ? items.filter(i => { const hay = text(i).toLowerCase(); return terms.every(t => hay.includes(t)); }) : items;
  }, [items, query]); // eslint-disable-line react-hooks/exhaustive-deps
  const searching = query.trim() !== "";
  const rows = searching || expanded ? matched : matched.slice(0, limit);
  return { query, setQuery, expanded, setExpanded, matched, rows, total: items.length, searching, limit };
}

export function ListBar({ view, noun = "contacts", placeholder = "Search…" }) {
  const { query, setQuery, expanded, setExpanded, matched, rows, total, searching, limit } = view;
  if (total <= limit && !searching) return null;
  return <div className="list-bar">
    <div className="inline-search"><Search size={15} /><input value={query} onChange={e => setQuery(e.target.value)} placeholder={placeholder} aria-label={`Search ${noun}`} /></div>
    <small className="muted">{searching ? `${matched.length} of ${total} ${noun} match` : `Showing ${rows.length} of ${total} ${noun}`}</small>
    {!searching && (total > limit) && <button className="link-button" onClick={() => setExpanded(!expanded)}>{expanded ? "Show fewer" : `Show all ${total}`}</button>}
  </div>;
}
